let currentLang = 'en';
        
        function setLanguage(lang) {
            currentLang = lang;
            
            // Update button states
            document.querySelectorAll('.lang-btn').forEach(btn => btn.classList.remove('active'));
            event.target.classList.add('active');
            
            // Show/hide forms
            document.getElementById('form-en').style.display = lang === 'en' ? 'block' : 'none';
            document.getElementById('form-el').style.display = lang === 'el' ? 'block' : 'none';
            
            // Hide thank you messages
            document.getElementById('thankyou-en').classList.remove('show');
            document.getElementById('thankyou-el').classList.remove('show');
        }
        
        function handleSubmit(event, lang) {
            event.preventDefault();
            
            const email = document.getElementById(`email-${lang}`).value;
            
            // Log email (replace this with your email service integration)
            console.log('Email collected:', email, 'Language:', lang);
            
            // Here you would typically send the email to your email service
            // For example: Mailchimp, ConvertKit, MailerLite, etc.
            // 
            // Example with a webhook:
            // fetch('YOUR_WEBHOOK_URL', {
            //     method: 'POST',
            //     body: JSON.stringify({ email: email, language: lang }),
            //     headers: { 'Content-Type': 'application/json' }
            // });
            
            // Hide form, show thank you
            document.getElementById(`form-${lang}`).style.display = 'none';
            document.getElementById(`thankyou-${lang}`).classList.add('show');
        }